module.exports = __webpack_public_path__ + "img/Img4.05433013.jpg";